const Moment = require('moment');

module.exports = function(key) {
    const t = Moment(key).local();

    if(!t.isValid()) {
        return '---';
    }

    return t.format('YYYY/MM/DD HH:mm');
};



// WEBPACK FOOTER //
// ./common/ui/template/helper/time_full.js